import { z } from "zod";

export const shopifyIntegrationConfigSchema = z
  .object({
    id: z.uuid(),
    name: z.string().nullish(),
    shopifyUrl: z.string(),
    url: z.string().nullish(),
    accessScopes: z.string().nullish(),
    webPixelId: z.string().nullish(),
  })
  .describe("ShopifyIntegrationData");
